import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { distinctUntilChanged, filter, map, switchMap, take } from 'rxjs/operators';

import { VrcAuthService } from './vrc-auth.service';
import { of } from 'rxjs';

export const vrcAuthGuard: CanActivateFn =
  (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const _r = inject(Router);
    const _auth = inject(VrcAuthService);
    const _isInIframe = () => {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    };
    if (!_isInIframe()) {
      //_st.contactId = null; 
    }
    if (!!_auth.getCustomAccessToken() && !_auth.isCustomAccessTokenExpired()) {
      return true;
    }
    return _auth.isLoggedIn$.pipe(switchMap(x => {
      if (x) { return of(true); }
      if (_auth.IsAzureUser) { return of(true); }
      // return _r.createUrlTree(['/login']);
      return _auth.msalIsInitiazedObservable.pipe(
        filter(x => x == true),
        map(x => {
          if (_auth.IsAzureUser) { return true; }
          var u=_r.createUrlTree(['/login'],{
            queryParams: { 
              url: state.url,
            }});
          return u;
        }),
        distinctUntilChanged()
      );
    }));
  };
